import { render } from "./App.vue?vue&type=template&id=6505b35d"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6505b35d&lang=less"

import exportComponent from "F:\\work\\projects\\HiOmics\\Front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__